/**
 * NPI suggestions at signup: the registry records a signing-up clinician most
 * likely is, offered for them to confirm instead of looking up their NPI.
 */
export type { NpiCandidate } from './model/types';
export { NpiSuggestionPicker } from './ui/picker/NpiSuggestionPicker';
export type { NpiSuggestionPickerProps } from './ui/picker/NpiSuggestionPicker';
